<template>
  <div id="app">
    <header v-if="!$route.meta.noLayout">
      <a href="/" class="logo-link">
        <img alt="Company Logo" src="./assets/logo.png" class="logo" />
      </a>
      <nav class="navbar">
        <button class="menu-toggle" @mouseover="openMenu" @mouseleave="closeMenu">
          ☰
        </button>
        <ul :class="{ 'active': isMenuOpen }" @mouseover="openMenu" @mouseleave="closeMenu">
          <li v-for="(item, index) in menuItems" :key="index">
            <router-link :to="item.to" @click="closeMenu">{{ item.label }}</router-link>
          </li>
          <template v-if="!isAuthenticated">
            <li><router-link to="/dang-nhap" @click="closeMenu">Đăng Nhập</router-link></li>
          </template>
          <template v-else>
            <li><span>{{ email }}</span></li>
            <li><router-link to="/" @click="closeMenu">HKOIL</router-link></li>
            <li><router-link to="/logout" @click="closeMenu">User Profile</router-link></li>
            <li><router-link to="/profile" @click="closeMenu">Attendance</router-link></li>
          </template>
        </ul>
      </nav>
    </header>
    <main>
      <div :class="{ 'content-container': !$route.meta.noLayout }">
        <router-view :systems="systems" v-if="!$route.meta.hkUser" />
        <router-view :userSystems="userSystems" v-if="$route.meta.hkUser" />
        <router-view :retailSystems="retailSystems" v-if="$route.meta.hkRetails" />
        <router-view :driverSystems="driverSystems" v-if="$route.meta.hkDrivers" />
        <button v-if="pwaStore.deferredPrompt" class="install-button" @click="pwaStore.promptInstall">
          Cài Đặt Ứng Dụng
        </button>
      </div>
    </main>
    <footer>
      <p>&copy; 2024 HKOIL. Tất cả các quyền được bảo lưu.</p>
    </footer>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue';
import { usePWAStore } from './stores/usePWAStore'; // Import store
import { useAuthStore } from './stores/authStore'; // Import auth store
import contractImg from '@/assets/ioffice/contract.png';
import wholesaleImg from '@/assets/ioffice/wholesale.png';
import gasImg from '@/assets/ioffice/gas-station.png';
import igasImg from '@/assets/ioffice/igas.png';
import paymentImg from '@/assets/ioffice/payment.png';
import hkLogoImg from '@/assets/logo.png';
import iOfficeImg from '@/assets/ioffice/ioffice.png';
import attendanceImg from '@/assets/ioffice/attendance.png';
import apcorp from '@/assets/ioffice/ap_corp.png';
import zaloImg from '@/assets/ioffice/zalo_ico.png';

import carRegImg from '@/assets/retails/carReg2.png';
import discountImg from '@/assets/retails/discount_ico2.png';
import cashbackImg from '@/assets/retails/cashback2.png';
import changeShiftImg from '@/assets/retails/change_shift.png';
import closeShiftImg from '@/assets/retails/close_shift.png';
import debitImg from '@/assets/retails/db_ico2.png';
import inhouseImg from '@/assets/retails/inhouse_ico2.png';
import perpaidImg from '@/assets/retails/prepaid_ico3.png';
import vehicleImg from '@/assets/retails/vehicle_ico2.png';
//import invoiceImg from '@/assets/retails/e-invoice.png';
import voucherImg from '@/assets/retails/voucher.png';
import qrPaymentImg from '@/assets/retails/payment_ico.png';
import gifttImg from '@/assets/retails/gift.png';

export default defineComponent({
  name: 'App',
  setup() {
    const pwaStore = usePWAStore(); // Khởi tạo store PWA
    const authStore = useAuthStore(); // Khởi tạo store Auth

    const isAuthenticated = computed(() => authStore.isAuthenticated); // Kiểm tra trạng thái đăng nhập
    const email = computed(() => authStore.email || ''); // Lấy email từ auth store

    return { pwaStore, isAuthenticated, email };
  },
  data() {
    return {
      isMenuOpen: false,
      menuItems: [
        { label: 'Trang Chính', to: '/' },
        { label: 'Về Chúng Tôi', to: '/about' },
        { label: 'Hệ thống HKOIL', to: '/hkoil' },
        { label: 'Chấm công', to: '/att-user' },
        { label: 'Thông báo', to: '/att-pe' },
        { label: 'Roadmap', to: '/timeline' },
      ],
      systems: [
                    { id: 1, name: "1. Hợp đồng HKOIL", link: "https://dochkoil.zohocreatorportal.com", image: contractImg },
                    { id: 2, name: "2. Đại lý", link: "https://hkoilw24.zohocreatorportal.com", image: wholesaleImg },
                    { id: 3, name: "3. Bán Lẻ", link: "https://hkoil24.zohocreatorportal.com", image: gasImg },
                    { id: 4, name: "4. Đề nghị thanh toán", link: "https://duyetchi.hkoil.org", image: paymentImg },
                    { id: 5, name: "5. Kho Anh Phát Petro", link: "http://cms.terminal.apc.vn/login", image: apcorp },
                    { id: 6, name: "6. IGAS", link: "https://data.igas.vn", image: igasImg },
                    { id: 7, name: "7. Văn phòng", link: "/", image: iOfficeImg },
                    { id: 8, name: "8. Chấm Công", link: "/att-user", image: attendanceImg },
                    /*{ id: 9, name: "9. Đánh giá nhân sự", link: "https://veas.hkoil.org", image: hkLogoImg },*/
                    { id: 9, name: "9. Công cụ tiện ích", link: "https://techcombank.com/cong-cu-tien-ich", image: hkLogoImg },
                    { id: 10, name: "10. Notifications", link: "/att-pe", image: hkLogoImg },
                    { id: 11, name: "11. Tính thuế TNCN", link: "https://www.topcv.vn/tinh-thue-thu-nhap-ca-nhan", image: hkLogoImg },
                    { id: 12, name: "12. Xin nghỉ phép", link: "#", image: hkLogoImg },
                    { id: 13, name: "13. Tính lãi suất vay", link: "/loan", image: hkLogoImg },
                    { id: 14, name: "14. Zalo", link: "zalo://", image: zaloImg },
                    { id: 15, name: "15. HKOIL AI", link: "https://chatgpt.com/g/g-luwb0tPAW-hkoil-ai", image: hkLogoImg },
                    { id: 16, name: "16. ZaloWeb", link: "https://zalo.me", image: zaloImg },
                    // ... Thêm nhiều hệ thống khác tại đây   image: new URL('@/assets/ioffice/contract.png', import.meta.url).href
            ],
      userSystems: [
                          { id: 1, name: "1. Hợp đồng HKOIL", link: "https://creatorapp.zoho.com/zoho_thuan14/doc", image: contractImg },
                          { id: 2, name: "2. Đại lý", link: "https://creatorapp.zoho.com/zoho_thuan14/hkw", image: wholesaleImg },
                          { id: 3, name: "3. Bán Lẻ", link: "https://creatorapp.zoho.com/zoho_thuan14/hkr", image: gasImg },
                          { id: 4, name: "4. Đề nghị thanh toán", link: "https://creatorapp.zoho.com/zoho_thuan14/oscar", image: paymentImg },
                          { id: 5, name: "5. Kho Anh Phát Petro", link: "http://cms.terminal.apc.vn/login", image: apcorp },
                          { id: 6, name: "6. IGAS", link: "https://data.igas.vn", image: igasImg },
                          { id: 7, name: "7. Văn phòng", link: "/", image: iOfficeImg },
                          { id: 8, name: "8. Chấm Công", link: "/att-user", image: attendanceImg },
                          /*{ id: 9, name: "9. Đánh giá nhân sự", link: "https://veas.hkoil.org", image: hkLogoImg },*/
                          { id: 9, name: "9. Công cụ tiện ích", link: "https://techcombank.com/cong-cu-tien-ich", image: hkLogoImg },
                          { id: 10, name: "10. Notifications", link: "/att-pe", image: hkLogoImg },
                          { id: 11, name: "11. Tính thuế TNCN", link: "https://www.topcv.vn/tinh-thue-thu-nhap-ca-nhan", image: hkLogoImg },
                          { id: 12, name: "12. Xin nghỉ phép", link: "#", image: hkLogoImg },
                          { id: 13, name: "13. Tính lãi suất vay", link: "/loan", image: hkLogoImg },
                          { id: 14, name: "14. Tính lãi suất tiết kiệm", link: "/saving", image: hkLogoImg },
                          // ... Thêm nhiều hệ thống khác tại đây   image: new URL('@/assets/ioffice/contract.png', import.meta.url).href
                  ],
                         retailSystems: [
                                             { id: 1, name: "Khai báo xe", link: "https://hkoil24.zohocreatorportal.com/#Report:Ds_Xe_001", image: carRegImg },
                                             { id: 2, name: "Chiết khấu trực tiếp", link: "https://hkoil24.zohocreatorportal.com/#Report:Chiet_khau_truc_tiep_101", image: discountImg },
                                             { id: 3, name: "Hoàn tiền", link: "https://hkoil24.zohocreatorportal.com/#Report:Hoan_tien_201", image: cashbackImg },
                                             { id: 4, name: "Ghi nợ", link: "https://hkoil24.zohocreatorportal.com/#Report:Ghi_no_301", image: debitImg },
                                             { id: 5, name: "Nội bộ", link: "https://hkoil24.zohocreatorportal.com/#Report:Noi_bo_501", image: inhouseImg },
                                             { id: 6, name: "Trả trước", link: "https://hkoil24.zohocreatorportal.com/#Report:Tra_truoc_601", image: perpaidImg },
                                             { id: 7, name: "Vãng lai", link: "https://hkoil24.zohocreatorportal.com/#Report:Khuyen_mai_901", image: vehicleImg },
                                             { id: 8, name: "Voucher", link: "https://hkoil24.zohocreatorportal.com/#Report:BC_su_dung_voucher_801", image: voucherImg },
                                             { id: 9, name: "Giao ca", link: "https://hkoil24.zohocreatorportal.com/#Report:BC_tong_hop_ca_mo", image: changeShiftImg },
                                             { id: 10, name: "Ca đã đóng", link: "https://hkoil24.zohocreatorportal.com/#Report:BC_Ca_da_dong", image: closeShiftImg },
                                             { id: 11, name: "Xuất hóa đơn", link: "http://data.igas.vn", image: igasImg },
                                             { id: 12, name: "K-One", link: "/", image: hkLogoImg },
                                             { id: 13, name: "Tích điểm", link: "/saving", image: gifttImg },
                                             { id: 14, name: "Thanh toán", link: "/", image: qrPaymentImg },
                                             // ... Thêm nhiều hệ thống khác tại đây   image: new URL('@/assets/ioffice/contract.png', import.meta.url).href
                                     ],
                                                               driverSystems: [
                                                                                   { id: 1, name: "Đơn hàng hôm nay", link: "https://hkoil24.zohocreatorportal.com/#Report:Ds_Xe_001", image: carRegImg },
                                                                                   { id: 2, name: "Toàn bộ đơn hàng", link: "https://hkoil24.zohocreatorportal.com/#Report:Chiet_khau_truc_tiep_101", image: discountImg },
                                                                                   { id: 3, name: "Hoàn tiền", link: "https://hkoil24.zohocreatorportal.com/#Report:Hoan_tien_201", image: cashbackImg },
                                                                                   { id: 4, name: "Ghi nợ", link: "https://hkoil24.zohocreatorportal.com/#Report:Ghi_no_301", image: debitImg },
                                                                                   { id: 5, name: "Nội bộ", link: "https://hkoil24.zohocreatorportal.com/#Report:Noi_bo_501", image: inhouseImg },
                                                                                   { id: 6, name: "Trả trước", link: "https://hkoil24.zohocreatorportal.com/#Report:Tra_truoc_601", image: perpaidImg },
                                                                                   { id: 7, name: "Vãng lai", link: "https://hkoil24.zohocreatorportal.com/#Report:Khuyen_mai_901", image: vehicleImg },
                                                                                   { id: 8, name: "Voucher", link: "https://hkoil24.zohocreatorportal.com/#Report:BC_su_dung_voucher_801", image: voucherImg },
                                                                                   { id: 9, name: "Giao ca", link: "https://hkoil24.zohocreatorportal.com/#Report:BC_tong_hop_ca_mo", image: changeShiftImg },
                                                                                   { id: 10, name: "Ca đã đóng", link: "https://hkoil24.zohocreatorportal.com/#Report:BC_Ca_da_dong", image: closeShiftImg },
                                                                                   { id: 11, name: "Xuất hóa đơn", link: "http://data.igas.vn", image: igasImg },
                                                                                   { id: 12, name: "K-One", link: "/", image: hkLogoImg },
                                                                                   { id: 13, name: "Tích điểm", link: "/saving", image: gifttImg },
                                                                                   { id: 14, name: "Thanh toán", link: "/", image: qrPaymentImg },
                                                                                   // ... Thêm nhiều hệ thống khác tại đây   image: new URL('@/assets/ioffice/contract.png', import.meta.url).href
                                                                           ]
    };
  },
  methods: {
    openMenu() {
      this.isMenuOpen = true;
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
  },
  mounted() {
    document.title = 'HKOIL I-OFFICE';
  },
});
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  background: linear-gradient(90deg, #ffcf3ec2, #ff805cbd);
  animation: gradient-shift 6s infinite alternate;
  color: #fff;
  background-size: 400% 400%;
}

@keyframes gradient-shift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.logo {
  width: 100px;
  height: auto;
}

.navbar ul {
  display: flex;
  gap: 15px;
  list-style: none;
  padding: 0;
  margin: 0;
}

.navbar li {
  transition: transform 0.2s ease, color 0.3s ease;
}

.navbar li:hover {
  transform: translateY(-5px);
  color: #007acc;
}

.menu-toggle {
  display: none;
}
.menu-toggle:hover {
  transform: scale(1.2); /* Phóng to nhẹ khi hover */
}

@media (max-width: 768px) {
  .menu-toggle {
    display: block;
    font-size: 1.5rem;
    color: #fff;
    background: none;
    border: none;
    cursor: pointer;
  }

  .navbar ul {
    display: none;
    flex-direction: column;
    position: absolute;
    top: 60px;
    left: 0;
    width: 100%;
    background: #ffffff;
    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);
  }

  .navbar ul.active {
    display: flex;
  }

  .navbar li {
    text-align: center;
  }
}

a {
  text-decoration: none;
  color: #fff;
  font-weight: bold;
  padding: 10px 15px;
  border-radius: 5px;
  transition: background 0.3s ease;
  border-radius: 100px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

a:hover {
  background: rgba(255, 255, 255, 0.2);
}

footer {
  text-align: center;
  background: #f3f3f3;
  padding: 15px;
  font-size: 0.9rem;
  border-top: 1px solid #eaeaea;
  margin-top: auto;
}

main {
  flex: 1;
  /*display: flex;*/
  justify-content: center;
  align-items: flex-start;
  /*padding: 20px;*/
}

.content-container {
  /*padding: 20px;*/
  background: white;
  border-radius: 8px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
}

/* Responsive Styles */
@media (max-width: 768px) {
  /* Chỉ áp dụng cho menu trong .navbar, tránh ảnh hưởng đến toàn bộ nav ul trên trang */
  .navbar ul {
    display: none;
    flex-direction: column;
    width: 100%;
    background-color: #ffcf3ec2;
    position: absolute;
    top: 60px;
    left: 0;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    z-index: 10;
  }

  .navbar ul.active {
    display: flex;
  }

  .navbar .menu-toggle {
    display: block;
  }

  .navbar li {
    margin: 10px 0;
  }

  .navbar a {
    padding: 9px;
    font-size: 18px;
  }
}

.install-button {
  display: inline-block;
  padding: 10px 20px;
  margin-top: 20px;
  background-color: #FF6347;
  color: white;
  font-size: 16px;
  font-weight: bold;
  border-radius: 25px;
  text-decoration: none;
  transition: transform 0.3s ease, background-color 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 99, 71, 0.4);
}

.install-button:hover {
  transform: translateY(-5px) scale(1.05);
  background-color: #FF4500;
  box-shadow: 0 6px 25px rgba(255, 69, 0, 0.6);
}

.install-button:active {
  transform: scale(0.95);
}
</style>

